module.exports = __webpack_public_path__ + "static/media/left-doble-arow.f0315024.svg";